// src/sections/logos.js
import React from 'react';
import styled from 'styled-components';
import LogoSlider from '../logoslider';

const StyledLogoSection = styled.section`
  max-width: 1000px;
  margin: 0 auto;
  padding: 100px 0;

  @media (max-width: 768px) {
    padding: 80px 0;
  }

  @media (max-width: 480px) {
    padding: 60px 0;
  }

  h2 {
    text-align: center;
    color: var(--light-slate);
    margin-bottom: 50px;
    font-size: clamp(24px, 5vw, 36px);
  }
`;

const Logos = () => {
  return (
    <StyledLogoSection id="logos">
      <LogoSlider />
    </StyledLogoSection>
  );
};

export default Logos;
